export default __webpack_public_path__ + "static/media/notifcation.4d422708.mp3";